export default __webpack_public_path__ + "static/media/refugeecamp.de6ad3ce.jpg";